var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered"},[_c('img',{attrs:{"src":_vm.referenceURL,"alt":_vm.questionTitle,"title":_vm.questionDescription}})])}
var staticRenderFns = []

export { render, staticRenderFns }